<div class="clients-page">
  <div class="content-box">
    <div class="row">
      <div class="col-sm-12 clients-page__content">
        <div class="clients-card">
          <div class="clients-card__header">
            <img src="/assets/images/Group 9.svg" alt="" />
            <div class="clients-card__header-headline">
              <h4>Galerie</h4>
            </div>
          </div>
          <button *ngIf="permissionsService.hasPermission('auth-module.gallery.add')"
          (click)="openAddDialog()"
          type="button"
          class="btn btn-sm btn-white pull-right ms-1"
          >
          <i class="fa-solid fa-plus"></i>
          Adaugă
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

  
  <div class="image-row">
    <div class="image-container" *ngFor="let image of images; let i = index">
      <img [src]="buildImagePath(image)" [alt]="image.original_filename">
      <div class="overlay">
        <a class="icon download-icon" (click)="openImgDialog(image)">
          <img src="/assets/icons/add.svg" alt="Download"></a>
        <a 
           class="icon delete-icon" (click)="deleteImage(image.id)" 
           *ngIf="permissionsService.hasPermission('auth-module.gallery.delete')"
        >
          <img src="/assets/icons/delete.svg" alt="Delete">
        </a>
      </div>
    </div> 
  </div>
  <div class="section-spinner position-absolute" *ngIf="isLoading">
    <div class="spinner position-absolute top-50 start-50 translate-middle">
      <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
    </div>
  </div>

